import React from "react"
import { Box } from "@mui/material"

import ReportsAutocomplete from "./Reports"
import PageWrapperAnalyzers from "Pages/@PageWrapper/Actions/Analyzers"


export default function PageWrapperActions({ showReportsSelect, showAnalyzersLinks, directsite, reportSelectorProps = {} }) {

	return <Box sx={{
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		gap: 1
	}}>
		{!!showReportsSelect && <Box sx={{ minWidth: 300, mr: 2 }}>
			<ReportsAutocomplete directsite={directsite} {...reportSelectorProps}/>
		</Box>}
		{!!showAnalyzersLinks && <PageWrapperAnalyzers/>}

	</Box>
}